import type { TwinEvent } from '@hofsync/design-system';

export const MOCK_EVENTS: TwinEvent[] = [
  {
    event_id: 'evt-001',
    event_type: 'contract_fulfilled',
    severity: 'info',
    status: 'new',
    category: 'lifecycle',
    explanation:
      'Kontrakt K-2024-001 ist erfüllt: Es wurden 97.5% der vereinbarten Menge geliefert. Es ist kein weiterer Handlungsbedarf nötig.',
    entity_id: 'c-001',
    entity_type: 'purchase_agreement',
    metric_values: { fulfillment_pct: 97.5, status: 'fulfilled' },
    evidence_doc_ids: ['doc-001', 'doc-002'],
    created_at: '2024-04-25T14:30:00Z',
    resolved_at: null,
    contract_number: 'K-2024-001',
    supplier_name: 'Raiffeisen Waren-Zentrale Rhein-Main eG',
  },
  {
    event_id: 'evt-002',
    event_type: 'missing_datasheet',
    severity: 'action_required',
    status: 'new',
    category: 'compliance',
    explanation:
      'Für das Düngemittel NitroSulf 24+6 S fehlt das Sicherheitsdatenblatt (SDB). Nach der EU-REACH-Verordnung (Art. 31 VO (EG) Nr. 1907/2006) und der Gefahrstoffverordnung (GefStoffV §6) muss beim gewerblichen Umgang mit Düngemitteln ein aktuelles SDB vorliegen. Bitte fordern Sie das Datenblatt bei BayWa AG an.',
    entity_id: 'c-003',
    entity_type: 'purchase_agreement',
    metric_values: { datasheet_present: 0 },
    evidence_doc_ids: ['doc-020'],
    created_at: '2024-05-15T11:00:00Z',
    resolved_at: null,
    contract_number: 'K-2024-022',
    supplier_name: 'BayWa AG Niederlassung Mainz',
  },
  {
    event_id: 'evt-003',
    event_type: 'over_delivery_warning',
    severity: 'warning',
    status: 'new',
    category: 'general',
    explanation:
      'Überlieferung bei Kontrakt K-2024-008: Es wurden 108.5% der vereinbarten Menge (800 dt) geliefert. Bitte prüfen Sie, ob die Mehrlieferung gewollt war, und klären Sie ggf. mit Getreidehandel Müller & Söhne die Abrechnungsmodalitäten.',
    entity_id: 'c-005',
    entity_type: 'sales_agreement',
    metric_values: { fulfillment_pct: 108.5 },
    evidence_doc_ids: ['doc-040', 'doc-043'],
    created_at: '2024-09-20T10:00:00Z',
    resolved_at: null,
    contract_number: 'K-2024-008',
    supplier_name: 'Getreidehandel Müller & Söhne',
  },
  {
    event_id: 'evt-004',
    event_type: 'price_discrepancy',
    severity: 'action_required',
    status: 'new',
    category: 'reconciliation',
    explanation:
      'Preisabweichung bei Kontrakt K-2024-022: Der Vertragspreis beträgt 38.90 EUR, der tatsächliche Abrechnungspreis weicht um 7.2% ab. Bitte vergleichen Sie den Vertrags- mit dem Rechnungspreis und klären Sie die Differenz mit Ihrer Genossenschaft.',
    entity_id: 'c-003',
    entity_type: 'purchase_agreement',
    metric_values: { price_variance_pct: 7.2 },
    evidence_doc_ids: ['doc-020', 'doc-021'],
    created_at: '2024-05-20T09:00:00Z',
    resolved_at: null,
    contract_number: 'K-2024-022',
    supplier_name: 'BayWa AG Niederlassung Mainz',
  },
  {
    event_id: 'evt-005',
    event_type: 'contract_expiring',
    severity: 'warning',
    status: 'new',
    category: 'general',
    explanation:
      'Kontrakt K-2024-015 läuft in 28 Tagen ab (Lieferende: 2024-10-15). Bitte stellen Sie sicher, dass die ausstehende Menge rechtzeitig geliefert bzw. abgenommen wird.',
    entity_id: 'c-002',
    entity_type: 'purchase_agreement',
    metric_values: { days_until_expiry: 28 },
    evidence_doc_ids: ['doc-010'],
    created_at: '2024-09-17T08:00:00Z',
    resolved_at: null,
    contract_number: 'K-2024-015',
    supplier_name: 'Raiffeisen Waren-Zentrale Rhein-Main eG',
  },
  {
    event_id: 'evt-006',
    event_type: 'commission_mismatch',
    severity: 'action_required',
    status: 'new',
    category: 'reconciliation',
    explanation:
      'Kommissionsabweichung bei Kontrakt Erdbeeren-Verkauf (FRUTANiA): Laut Vertrag beträgt die Provision 283.50 EUR, tatsächlich wurden 250.00 EUR abgerechnet (Differenz: 33.50 EUR). Bitte vergleichen Sie die Abrechnungen und klären Sie die Differenz mit Ihrer Genossenschaft.',
    entity_id: 'c-004',
    entity_type: 'sales_agreement',
    metric_values: {
      expected_commission: 283.5,
      actual_commission: 250.0,
      commission_delta: 33.5,
    },
    evidence_doc_ids: ['doc-030'],
    created_at: '2024-08-16T09:00:00Z',
    resolved_at: null,
    contract_number: undefined,
    supplier_name: 'FRUTANiA Obst & Gemüse Vertriebs GmbH',
  },
  {
    event_id: 'evt-007',
    event_type: 'missing_datasheet',
    severity: 'action_required',
    status: 'new',
    category: 'compliance',
    explanation:
      'Für das Düngemittel Harnstoff 46% N fehlt das Sicherheitsdatenblatt (SDB). Nach der EU-REACH-Verordnung (Art. 31 VO (EG) Nr. 1907/2006) und der Gefahrstoffverordnung (GefStoffV §6) muss beim gewerblichen Umgang mit Düngemitteln ein aktuelles SDB vorliegen. Bitte fordern Sie das Datenblatt bei RWZ an.',
    entity_id: 'c-006',
    entity_type: 'purchase_agreement',
    metric_values: { datasheet_present: 0 },
    evidence_doc_ids: ['doc-050'],
    created_at: '2024-12-01T09:30:00Z',
    resolved_at: null,
    contract_number: 'K-2024-030',
    supplier_name: 'Raiffeisen Waren-Zentrale Rhein-Main eG',
  },
  {
    event_id: 'evt-008',
    event_type: 'unresolved_link',
    severity: 'warning',
    status: 'new',
    category: 'reconciliation',
    explanation:
      'Ein Dokument konnte keinem Kontrakt eindeutig zugeordnet werden. Es wurden mehrere mögliche Kontrakte gefunden. Bitte ordnen Sie das Dokument über die Schaltfläche „Zuordnen" dem richtigen Kontrakt zu.',
    entity_id: 'doc-099',
    entity_type: 'document',
    metric_values: {},
    evidence_doc_ids: ['doc-099'],
    created_at: '2024-07-10T11:00:00Z',
    resolved_at: null,
  },
  {
    event_id: 'evt-009',
    event_type: 'contract_fulfilled',
    severity: 'info',
    status: 'resolved',
    category: 'lifecycle',
    explanation:
      'Kontrakt K-2023-045 (Wintergerste) ist erfüllt: Es wurden 100% der vereinbarten Menge geliefert.',
    entity_id: 'c-old-1',
    entity_type: 'sales_agreement',
    metric_values: { fulfillment_pct: 100 },
    evidence_doc_ids: [],
    created_at: '2023-10-15T14:00:00Z',
    resolved_at: '2023-10-15T14:00:00Z',
    contract_number: 'K-2023-045',
    supplier_name: 'Getreidehandel Müller & Söhne',
  },
  {
    event_id: 'evt-010',
    event_type: 'missing_datasheet',
    severity: 'action_required',
    status: 'resolved',
    category: 'compliance',
    explanation: 'Sicherheitsdatenblatt für KAS nachgereicht.',
    entity_id: 'c-001',
    entity_type: 'purchase_agreement',
    metric_values: { datasheet_present: 1 },
    evidence_doc_ids: ['doc-003'],
    created_at: '2024-01-20T10:00:00Z',
    resolved_at: '2024-02-05T09:00:00Z',
    contract_number: 'K-2024-001',
    supplier_name: 'Raiffeisen Waren-Zentrale Rhein-Main eG',
  },
];
